// src/context/eventBus.js
// Pub/sub mínimo · zero dependências · não exposto em window.
//
// Eventos canônicos (catálogo):
// - 'tenant:changed'  · payload: { empresaId, prev }
// - 'tenant:hydrated' · payload: { empresaId, isSuperAdmin }
// - 'auth:signedin'   · payload: { userId }
// - 'auth:signedout'  · payload: {} — TODAS as caches devem ser limpas após este evento
// - 'cache:invalidate'· payload: { scope?: string } — invalida cache(s) por scope ou todos
// - 'error:critical'  · payload: { code, message, ctx }
//
// Cada subscriber deve estar preparado pra ser chamado várias vezes com o mesmo evento.

class EventBus {
  #listeners = new Map(); // event → Set<fn>

  on(event, fn) {
    if (typeof fn !== 'function') throw new TypeError('eventBus.on requer função');
    if (!this.#listeners.has(event)) this.#listeners.set(event, new Set());
    this.#listeners.get(event).add(fn);
    return () => this.off(event, fn); // retorna unsubscribe
  }

  off(event, fn) {
    this.#listeners.get(event)?.delete(fn);
  }

  emit(event, payload = {}) {
    const set = this.#listeners.get(event);
    if (!set || set.size === 0) return;
    // Cópia defensiva (handler pode chamar off durante emit)
    [...set].forEach((fn) => {
      try {
        fn(payload);
      } catch (err) {
        console.error(`[eventBus] listener de "${event}" lançou:`, err);
      }
    });
  }

  /**
   * Listar quantos subscribers existem por evento (debug).
   * Não exposto em window — só uso interno via import.
   */
  _debug() {
    const out = {};
    for (const [event, set] of this.#listeners) out[event] = set.size;
    return out;
  }

  /**
   * Reset completo · usado em testes E2E e em hot-reload do Vite.
   * Em produção NÃO deve ser chamado — o TenantContext.clear() limpa via emit.
   */
  _resetAll() {
    this.#listeners.clear();
  }
}

export const eventBus = new EventBus();
